import type { User, UserAdmin, UserReplacement } from "@/api/generated/types.gen.ts";

type AnyUser = User | UserAdmin;

export interface ReplacementRow {
  approver: AnyUser;
  replacements: UserReplacement[];
  status: "actief" | "geen-dekking";
}

export function buildReplacementRows(
  approvers: AnyUser[],
  superAdmins: AnyUser[],
  reps: UserReplacement[],
): ReplacementRow[] {
  const byId = new Map<string, AnyUser>();
  for (const u of approvers) byId.set(u.id, u);
  for (const u of superAdmins) byId.set(u.id, u);

  const grouped = new Map<string, UserReplacement[]>();
  for (const r of reps) {
    const arr = grouped.get(r.approverId) ?? [];
    arr.push(r);
    grouped.set(r.approverId, arr);
  }

  const rows: ReplacementRow[] = [];
  for (const user of byId.values()) {
    const replacements = grouped.get(user.id) ?? [];
    rows.push({
      approver: user,
      replacements,
      status: replacements.length > 0 ? "actief" : "geen-dekking",
    });
  }

  rows.sort((a, b) => a.approver.name.localeCompare(b.approver.name, "nl"));
  return rows;
}
